// extracted by mini-css-extract-plugin
export default {"movieList":"MovieList_movieList__uFrOZ","emptyResult":"MovieList_emptyResult__izyT1"};